import { useEffect, useState } from 'react'
import { BiX } from 'react-icons/bi'
import { getDocCollection, updateItem, registrarProfessor } from "../../../firebase/CRUD"
import { useAuth } from '../../../hooks/AuthContext'
import { useToast } from '../../../hooks/Toast'
import Input from '../../layout/Input/Input'
import Button from '../../layout/Button/Button'
import { Selection } from '../../layout/Selection/Selection'
import ContainerForm from '../../layout/Form/ContainerForm'


export default function ProfessorAdd({cadastramento, edit}){
    const {usuario} = useAuth()
    const {mostrarAviso} = useToast()
  
    const [turmas, setTurmas] = useState([])
    const [carregando, setCarregando] = useState(false)
    
    const [formData, setFormData] = useState(edit || {
        email: '',
        senha: '',
        nome: '',
        genero: '',
        dataNascimento: new Date(),
        turma: '',
        turmaNome: '',
        presencas: 0,
        pontos: 0,
        oferta: false,
        biblia: false,
        revista: false,
        historico:{
            biblias:[0,0,0,0],
            revistas:[0,0,0,0],
            presencas:[0,0,0,0],
            pontos:[0,0,0,0],
        }
    })

    const buscar = (key,lista)=>{
        const tam = lista.length
        console.log(lista)
        for(let i = 0; i < tam; i++){
            if(key == lista[i].id){
                return lista[i].nome
            }
        }
    }
    
    const handleInputChange = (e)=>{
        const {name, value} = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }

    // REMOVIDO: dropdown de "Perfil" (prof/adm). O backend (Cloud Function
    // criarProfessorAuth) sempre grava cargo:"professor" para quem é criado
    // por aqui, ignorando qualquer valor vindo do formulário — então esse
    // seletor nunca teve efeito real. Pior: é uma armadilha de segurança:
    // se um dia alguém "consertar" isso para respeitar o valor escolhido,
    // reabre o escalonamento de privilégio que foi corrigido no backend.
    // Promoções a admin devem passar exclusivamente pela function
    // `setarCargoAdm`, que já tem a checagem de permissão correta.
    useEffect(()=>{
        getDocCollection("turmas",setTurmas,usuario.idEscola)
    },[])

    const salvar = async (e)=>{
        e.preventDefault()
        formData.nomeTurma = buscar(formData.turma,turmas)
        if(edit){
            updateItem('professores',edit.id,formData,usuario.idEscola)
            cadastramento()
            // REMOVIDO: bloco antigo que tentava empurrar o id do professor
            // num array `turma.professor` e depois chamava
            // updateItem("turmas", turma, ...) — "turma" aqui era um
            // useState que NUNCA recebia setTurma(...), então ficava ""
            // pra sempre. Isso fazia o Firestore rejeitar a escrita (ID de
            // documento vazio) toda vez que um professor era editado.
            // Esse modelo (array de professores dentro da turma) foi
            // substituído pela subcoleção `turmas/{id}/membros`, que já é
            // gravada corretamente dentro de `registrarProfessor` no CRUD.js.
            return
        }

        // CORREÇÃO: antes o import (`registarProfessor`, com typo) resolvia
        // para `undefined` e quebrava aqui. Além disso os argumentos
        // estavam fora de ordem: no lugar de `idTurmaDestino` (uma string,
        // o id da turma escolhida) estava sendo passado `formData` inteiro,
        // e `idTurmaProfessores` nunca era passado (undefined) — o vínculo
        // automático do professor como aluno na Turma de Professores nunca
        // era criado corretamente.
        // ATUALIZAÇÃO: não é mais necessário procurar a turma "Professores"
        // aqui — a Cloud Function `criarProfessorAuth` já busca isso
        // sozinha em `escolas/{idEscola}.turmaProfessoresId`. Isso também
        // elimina o erro que acontecia quando o professor era criado antes
        // do pagamento da assinatura ser confirmado (a gravação agora roda
        // toda no servidor, sem passar pelas Security Rules do client).
        await registrarProfessor(
            formData,
            formData.email,
            formData.senha,
            usuario.idEscola,
            formData.turma
        )
        cadastramento()
    }
    return(
    <ContainerForm cadastramento={cadastramento} finalizar={salvar}>
        <Input 
            label={'Nome do professor'}
            name={'nome'}
            value={formData.nome}
            onChange={handleInputChange}
            placeholder={'Digite o nome do professor'}
            minLength={1}
            required={true}
        />
        <div className='radioGoup'>
            <span className='radioLabel'>Gênero:</span>
            <div className='radioOptions'>
            <label className='radioOption'>
                <input 
                type="radio" 
                name="genero" 
                value="M" 
                onChange={handleInputChange} 
                checked={formData?.genero === "M"} 
                required 
                />
                Masculino
            </label>
            <label className='radioOption'>
                <input 
                type="radio" 
                name="genero" 
                value="F" 
                onChange={handleInputChange} 
                checked={formData?.genero === "F"} 
                />
                Feminino
            </label>
            </div>
        </div>
        <div>
            <Input 
                label={'Nascimento'}
                value={formData.dataNascimento}
                onChange={handleInputChange}
                type='date'
                name={'dataNascimento'}
                required={true}
            />
        </div>
        <div>
            {usuario.perfil == "adm" &&
                Selection(
                    {
                        name:"turma",
                        text:"Turma: ",handleOnChange:handleInputChange,
                        options:turmas,
                        value:formData.turma
                    })
            }{
                usuario.perfil == 'professor' &&
            <div className='inputReadonlyWrapper'>
            <label>Turma</label>
            <input 
                type="text" 
                className='inputReadonly' 
                value={formData.turmaNome || 'Sua Turma Padrão'} 
                readOnly 
            />
            </div> 
            }
        </div>
        
              
        {/* Seletor de "Perfil" removido — ver comentário acima de onde "perfis" era definido */}
                {!edit && <>
                <Input 
                    label={"E-mail:"}
                    name={'email'}
                    placeholder='Digite um E-mail válido'
                    value={formData.email}
                    onChange={handleInputChange}
                />
                <Input 
                    label={'Senha:'}
                    name={'senha'}
                    type='password'
                    placeholder='Digite a senha'
                    value={formData.senha}
                    onChange={handleInputChange}
                    minLength={6}
                />  </>}
                <Button type='submit'>
                    Salvar
                </Button> 
    </ContainerForm>
    
    )
}